import { RichTextBlock } from "./richTextBlock";

interface RichTextBlockFactoryOptions {
  fullWidth?: boolean;
  fundsDetailPage?: boolean;
}

interface RichTextProperties {
  title?: {
    markup?: string;
  };
  body?: {
    markup?: string;
  };
  richtText?: {
    markup?: string;
  };
  subTitle?: string;
}

function richTextBlockFactory(
  data: ContentBlock,
  key: number | string,
  {
    fullWidth = false,
    fundsDetailPage = false,
  }: RichTextBlockFactoryOptions = {},
): JSX.Element {
  const content = data?.content?.properties as RichTextProperties;

  return (
    <RichTextBlock
      key={key}
      title={content?.title?.markup}
      markup={content?.body?.markup ?? content?.richtText?.markup}
      subTitle={content?.subTitle}
      fullWidth={fullWidth}
      fundsDetailPage={fundsDetailPage}
    />
  );
}
export default richTextBlockFactory;
